// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5209baab","703":"70a418d7","787":"04eda858"}[chunkId] + ".chunk.js";
};